/* @ts-nocheck */
/* eslint-disable */
(function () {
  if (window.c21HeroScrollBound) return;
  window.c21HeroScrollBound = true;

  var SELECTOR = '[data-c21-hero-scroll]';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  // Same target as assets/c21-hero-carousel.js scrollToNextFold(): the content directly below the hero image.
  function scrollPastHero(hero) {
    var target = hero.getBoundingClientRect().bottom + window.scrollY;
    window.scrollTo({ top: target, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
  }

  document.addEventListener('click', function (evt) {
    var hero = evt.target.closest(SELECTOR);
    if (hero) scrollPastHero(hero);
  });

  document.addEventListener('keydown', function (evt) {
    if (evt.key !== 'Enter' && evt.key !== ' ') return;
    var hero = evt.target.closest(SELECTOR);
    if (!hero) return;
    evt.preventDefault();
    scrollPastHero(hero);
  });
})();
